import { VETERANS_INSURANCE_PROVIDER } from 'constants/defaults';
import { PRICE_POINT_CATEGORY_INSURANCE } from 'constants/pricepoints';

import { SelectInsuranceProvider } from 'models/insurance.types';
import { AdditionalInfo, PricePoint } from 'models/plans.types';

import { parseDecimal } from 'utils/payment';

import { hardcodedInsuranceProviders, hardcodedInsuranceProvidersExtended } from './constants';

export const getMappedInsuranceOptions = (
  data?: SelectInsuranceProvider[],
  loading?: boolean
): SelectInsuranceProvider[] => {
  if (!data?.length) {
    return loading
      ? []
      : [
          ...hardcodedInsuranceProvidersExtended,
          {
            _id: 'other',
            label: 'Other',
            value: 'other'
          }
        ];
  }
  return [
    ...[...data].sort((a) => (a?.insuranceType === 'medicare' ? -1 : 1)),
    {
      _id: 'medicaid',
      label: 'Medicaid',
      value: 'medicaid'
    },
    {
      _id: 'medicare_part_c',
      label: 'Medicare Part C (Medicare Advantage)',
      value: 'medicare_part_c'
    },
    {
      _id: 'veterans_tricare',
      label: VETERANS_INSURANCE_PROVIDER,
      value: 'veterans_tricare'
    },
    ...hardcodedInsuranceProviders.filter(
      (i) =>
        !data.some(
          (realProvider) =>
            realProvider.label.replace(/ /g, '').toLowerCase() ===
            i.label.replace(/ /g, '').toLowerCase()
        )
    ),
    {
      _id: 'other',
      label: 'Other',
      value: 'other'
    }
  ];
};

export const filterBalladHealthAdvantage = (value: string | AdditionalInfo) => {
  if (typeof value === 'string') {
    return (
      !value.toLowerCase().includes('insurance coverage') &&
      !value.toLowerCase().includes('complimentary metabolic')
    );
  }
  return (
    !value.question.toLowerCase().includes('insurance coverage') &&
    !value.question.toLowerCase().includes('complimentary metabolic')
  );
};

export const getCopay = (finalCost: number | undefined) => {
  if (finalCost === undefined) {
    return finalCost;
  }
  return `${parseDecimal(finalCost / 100)}`;
};

/**
 * Whether a single price point is an insurance price point.
 *
 * Total by design: an absent price point is `false`, never "unknown". Callers that need to
 * distinguish "not insured" from "not yet loaded" must track that themselves — see
 * `useMyPrograms`.
 */
export const isInsurancePricePoint = (pricePoint?: PricePoint | null): boolean =>
  !!pricePoint?.categories?.includes(PRICE_POINT_CATEGORY_INSURANCE);

/** Whether any of the given price points is an insurance price point. */
export const hasInsurancePricePoint = (pricePoints: PricePoint[]): boolean =>
  pricePoints.some(isInsurancePricePoint);
